
import { Action } from '../model';
import { IDataList } from '../model';
import { 
  INSTALLATIONS_ACTION_TYPES, 
  FetchInstallationsParams, 
  Installation 
} from './types';


export const fetchInstallationsRequest = (
  params?: FetchInstallationsParams,
  callback?: () => void
): Action<FetchInstallationsParams> => ({
  type: INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_REQUEST,
  payload: params || {},
});

export const fetchInstallationsSuccess = (
  data: IDataList<Installation[]>
): Action<IDataList<Installation[]>> => ({
  type: INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_SUCCESS,
  payload: data,
});

export const fetchInstallationsFailure = (
  error: string
): Action<string> => ({
  type: INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_FAILURE,
  payload: error,
}); 